<template>
  <div class="page">
	<div class="sidebar">
		<sidebar></sidebar>
	    <a href="javascript:;" class="back" @click="back()" v-show="currentDetail">
	    	<i></i>
	    </a>
	</div>
  	<div class="pageContainer">
  		<div class="pageTitle">
  			<h3>文章</h3>
  		</div>
  		<div class="pageContent">
  			<div class="pageList">
  				<ul>
  					<li v-for="(item,index) in list">
  						<a href="javascript:;" @click="SkipLink(index)">
  							<span>{{item.ListTitle}}</span>
  						</a>
  					</li>
  				</ul>
  			</div>
  		</div>
  	</div>
  	<div class="pageContainer details" :data="current" v-show="currentDetail">
  		<div class="pageTitle">
  			<h3>{{current.ListTitle}}</h3>
  		</div>
  		<div class="pageContent">
  			<div class="pageArticle" v-html="current.ListContent">{{current.ListContent}}</div>
  		</div>
  	</div>
  </div>
</template>

<script type="text/ecmascript-6">
	import Sidebar from 'base/sidebar/sidebar'
	import {ERR_OK} from 'api/config'
	import DataList from 'data/dataList.json'

	export default {
		data(){
			return{
				list:[],
				current:[],
				currentDetail:false
			}
		},
		created(){
			this._getListData()
		},
		methods:{
			_getListData(){
		         let _res = DataList
		         if(_res.status === ERR_OK){
		         	this.list = _res.data
		         }
			},
			back(){
				this.currentDetail = false;
				this.current = [];
			},
			SkipLink(i){
				let _data = this.list;
				this.current = _data[i];
				this.currentDetail = true;
			}
		},
	  	components: {
	  		Sidebar
	  	}
	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageList li{
		padding: 10px 0;
		line-height: 1.4;
		font-size: 16px;
		font-weight: 200;
	}

	.details{
		position: absolute;
		top: 0;
		right: 0;
		width: calc(100% - 560px);
		background-color: #fff;
		padding-left: 0;
	}
	.details .pageTitle{
		width: 660px;
		line-height: 1.2;
	}
	
	.back{
		display: block;
		position: absolute;
		right: 0;
		bottom: 60px;
		width: 40px;
		height: 20px;
		cursor: pointer;
	}
	.back i{
		display: block;
		width: 100%;
		height: 100%;
		background: url(~common/images/back.svg) center/contain no-repeat;
	}

	@media screen and (max-width:750px) {
		.pageList li{
		    padding: .2rem 0;
		    font-size: .28rem;
		}

		.details{
			top: 2.9rem;
			width: 100%;
			padding-top: .5rem;
		}
		.details .pageTitle{
			width: 100%;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}
		.back{
			right: auto;
			bottom: auto;
			left: .4rem;
			top: 3.1rem;
			width: 40px;
			height: 20px;
			z-index: 88;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/article/article.vue